import isNumber from "lodash/isNumber";

export const iconSize = (size) => {

    if (isNumber(size))
        return size;
    
    switch (size) {
        case 'xs':
            return 10;
        case 'sm':
            return 16;
        case 'md':
            return 20;
        case 'lg':
            return 24;
        case 'xl':
            return 28;
        case '2xl':
            return 35;
        case '3xl':
            return 45;
        case '4xl':
            return 50;
        default:
            return 20;
    }
};